import Vue from 'vue'
import VueResource from 'vue-resource'
import { networkError } from '../utils'
import { router, route } from '../router'
import * as mTypes from '../store/mutation-types'

Vue.use(VueResource)

const token = document.getElementById('lx_token').getAttribute('content')
Vue.http.interceptors.push((request, next) => {
  request.headers['X-CSRF-TOKEN'] = token
  next()
})

const failHandler = (res, fail, commit) => {
  if (fail) {
    fail(res)
  } else if (res.status === 401) {
    // 登录失效 非无权限的情况
    route.authenticated = false
    router.replace('/auth/login')

    commit(mTypes.SET_DIALOG_HTML, `<h1>${res.body.message}</h1>`)
  } else if (res.status === 404) {
    // 无权限
    router.replace('/main/dashboard')

    if (res.body.message !== undefined) {
      commit(mTypes.SET_DIALOG_HTML, `<h1>${res.body.message}</h1>`)
    }
  } else {
    networkError(commit)
  }
}

export const httpGet = (url, { success, fail, commit }) => {
  Vue.http.get(url).then(success, res => {
    failHandler(res, fail, commit)
  })
}

export const httpPost = (url, body, { success, fail, commit }) => {
  Vue.http.post(url, body).then(success, res => {
    failHandler(res, fail, commit)
  })
}

export const httpPatch = (url, body, { success, fail, commit }) => {
  Vue.http.patch(url, body).then(success, res => {
    failHandler(res, fail, commit)
  })
}

export const httpDelete = (url, { success, fail, commit }) => {
  Vue.http.delete(url).then(success, res => {
    failHandler(res, fail, commit)
  })
}
export const httpPostWithNoCommit = (url, body, { success, fail }) => {
  Vue.http.post(url, body).then(res => {
    if (success) success(res)
  }, res => {
    if (fail) fail(res)
  })
}



// WEBPACK FOOTER //
// ./src/api/utils.js